<template>
    <div>
        <v-form ref="form" v-model="formValid" lazy-validation>
            <v-form-base :col="12" :model="model" :schema="schema"/>
        </v-form>
    </div>
</template>

<script>
    import VFormBase from 'vuetify-form-base';

    const required = msg => v => !!v || msg
    const validEmail = msg => v => /.+@.+\..+/.test(v) || msg

    export default {
        components: {
            VFormBase,
        },

        props: {
            model: Object,
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                formValid: null,
            }
        },
        computed: {
            schema() {
                return {
                    invoiceName: {
                        type: 'text',
                        label: 'Name *',
                        disabled: this.disabled,
                        required: true,
                        rules: [ required('Name is required') ]
                    },
                    invoiceCompany: {
                        type: 'text',
                        label: 'Company',
                        disabled: this.disabled
                    },
                    invoiceEmail: {
                        type: 'email',
                        label: 'E-mail *',
                        disabled: this.disabled,
                        required: true,
                        rules: [ validEmail('E-mail not valid'), required('E-mail is required') ]
                    },
                    invoiceAddress1: {
                        type: 'text',
                        label: 'Address 1 *',
                        disabled: this.disabled,
                        rules: [ required('Address 1 is required') ]
                    },
                    invoiceAddress2: {
                        type: 'text',
                        label: 'Address 2',
                        disabled: this.disabled
                    },
                    invoiceAddress3: {
                        type: 'text',
                        label: 'Address 3',
                        disabled: this.disabled
                    },
                    invoiceTown: {
                        type: 'text',
                        label: 'Town *',
                        disabled: this.disabled,
                        rules: [ required('Town is required') ]
                    },
                    invoiceCounty: {
                        type: 'text',
                        label: 'County',
                        disabled: this.disabled
                    },
                    invoicePostcode: {
                        type: 'text',
                        label: 'Postcode *',
                        disabled: this.disabled,
                        rules: [ required('Town is required') ]
                    },
                    invoicePhone: {
                        type: 'text',
                        label: 'Phone *',
                        disabled: this.disabled,
                        rules: [ required('Phone is required') ]
                    },
                }
            }
        },
        methods: {
            validate () {
                return this.$refs.form.validate()
            },

            resetValidation () {
                this.$refs.form.resetValidation()
            },
        },
    }
</script>

<style scoped>

</style>